import React, { useEffect, useRef, useState } from "react";
import { Select } from "../../screens/User/Users/User.style";
import { FilledButton, OutlinedButton } from "../Forms/Button/buttons.style";
import {
  Dropdown,
  DropdownArea,
  DropdownUl,
  DropdownLi,
  ReportDropdownArea,
} from "./style";

const DropdownMenu = ({
  options,
  boxClasses,
  id,
  isReport,
  children,
  defaultOption,
}: any) => {
  //hook
  const dropdown = useRef<HTMLDivElement | null>(null);
  const [state, setstate] = useState(false);
  const [qapiVersion, setQapiVersion] = useState<string>(defaultOption);
  const [includeStatements, setIncludeStatements] = useState(false);
  const [includeConclusion, setIncludeConclusion] = useState(false);
  const [includeAttachments, setIncludeAttachments] = useState(false);
  const url = `/user/reports/${id}`;
  const QAPI = options[0].value;
  const isQapi = qapiVersion === QAPI;

  const searchParams = new URLSearchParams();
  if (isQapi) searchParams.set("version", "full");
  if (includeStatements) searchParams.set("includeStatements", "true");
  if (includeConclusion) searchParams.set("includeConclusion", "true");
  if (includeAttachments) searchParams.set("includeAttachments", "true");
  const queryString = searchParams.toString();
  const urlWithParams = queryString ? `${url}?${queryString}` : url;

  function onSelect(event: any): void {
    setQapiVersion(event.target.value);
    // Statements/Conclusion opt-ins only apply to the non-QAPI report.
    if (event.target.value === QAPI) {
      setIncludeStatements(false);
      setIncludeConclusion(false);
    }
  }

  const handleChange = () => {
    setstate(!state);
  };

  const handleIncludeStatementsChange = () => {
    setIncludeStatements(!includeStatements);
  };

  const handleIncludeConclusionChange = () => {
    setIncludeConclusion(!includeConclusion);
  };

  const handleIncludeAttachmentsChange = () => {
    setIncludeAttachments(!includeAttachments);
  };

  //closes the dropdown
  useEffect(() => {
    const hide = (e: any): void => {
      if (!dropdown?.current?.contains(e.target)) {
        setstate(false);
      }
    };

    if (isReport === undefined) window.addEventListener("mousedown", hide);
    return () => {
      if (isReport === undefined) window.removeEventListener("mousedown", hide);
    };
  }, []);

  return (
    <React.Fragment>
      <Dropdown className="coverNav">
        {isReport ? (
          <div onClick={handleChange}>
            {children}
            <ReportDropdownArea
              state={state}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Select
                style={{ width: "100%" }}
                value={qapiVersion}
                onChange={onSelect}
              >
                {options && Array.isArray(options) ? (
                  options.map((item: any) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))
                ) : (
                  <option value={options}>{options}</option>
                )}
              </Select>
              {
                <div>
                  <div className="mb-2 mt-2">
                    <input
                      type="checkbox"
                      checked={includeStatements}
                      onChange={handleIncludeStatementsChange}
                      disabled={isQapi}
                    />
                    <span>Include Statements and Interviews</span>
                  </div>
                  <div className="mb-2 mt-2">
                    <input
                      type="checkbox"
                      name="include-conclusion"
                      checked={includeConclusion}
                      onChange={handleIncludeConclusionChange}
                      disabled={isQapi}
                    />
                    <span>Include Conclusion</span>
                  </div>
                  <div className="mb-2 mt-2">
                    <input
                      type="checkbox"
                      name="include-attachment"
                      checked={includeAttachments}
                      onChange={handleIncludeAttachmentsChange}
                    />
                    <span id="include-attachment">Include Attachments</span>
                  </div>
                </div>
              }
              <div
                className="mb-2 mt-2"
                style={{ display: "flex", gap: "5px" }}
              >
                <OutlinedButton onClick={handleChange}>Cancel</OutlinedButton>
                <FilledButton
                  onClick={() =>
                    window.open(urlWithParams, "_blank", "noreferrer")
                  }
                >
                  View Report
                </FilledButton>
              </div>
            </ReportDropdownArea>
          </div>
        ) : (
          <div className="" onClick={handleChange} ref={dropdown}>
            {children}
            <DropdownArea
              isReport={isReport}
              state={state}
              className="custom-dropdown-menu"
            >
              <DropdownUl className={`menu-box ${boxClasses}`}>
                {options && Array.isArray(options) ? (
                  options.map((item, index) => (
                    <DropdownLi
                      className={` ${item.style} menu-item mb-2`}
                      key={index}
                      onClick={item.select}
                      style={{
                        borderTop: index !== 0 ? "0.5px solid #7A6482" : "",
                        paddingTop: index !== 0 ? "10px" : "",
                        marginTop: index !== 0 ? "10px" : "",
                      }}
                    >
                      {item.name}
                    </DropdownLi>
                  ))
                ) : (
                  <DropdownLi className="menu-item" onClick={onSelect}>
                    {options}
                  </DropdownLi>
                )}
              </DropdownUl>
            </DropdownArea>
          </div>
        )}
      </Dropdown>
    </React.Fragment>
  );
};

export default DropdownMenu;
